import React from 'react'
import { Divider } from '@olxbr/ds-web'
import { Skeleton } from '../../atoms'
import { SkeletonAnimation, StepButtonSkeleton } from '../../molecules'

const renderTaskSkeleton = last => (
  <div
    className="flex flex-col items-stretch"
    style={{ marginBottom: last ? null : 'var(--spacing-2)' }}
  >
    <StepButtonSkeleton />
  </div>
)

export const LevelStepsSkeleton = () => (
  <SkeletonAnimation>
    <div className="flex flex-1 flex-col items-stretch">
      <Skeleton type="title" />
      <Divider inverted marginBottom="--spacing-3" />
      {renderTaskSkeleton()}
      {renderTaskSkeleton()}
      {renderTaskSkeleton(true)}
    </div>
  </SkeletonAnimation>
)
